import { Component } from '@angular/core';

@Component({
  selector: 'app-html-image-content',
  imports: [],
  templateUrl: './html-image-content.component.html',
  styleUrl: './html-image-content.component.css'
})
export class HtmlImageContentComponent {

}
